import {
  pushAnalyticsObjToDataLayer,
  sanitizeTextForAnalytics,
} from "@/utils/helper"

export const partsAddToCartEvent = (analytics, productInfo) => {
  const { page = "n/a" } = analytics
  const linkUrl = window.location.href
  const event = "cmp:click"
  const newPage = page === "search results" ? "search results:modal" : page

  const eventInfo = {
    eventAction: page + ":modal:interactive parts diagram:add to cart",
    eventName: page + ":modal:interactive parts diagram:add to cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "add to cart",
    internalLinkPosition: newPage,
    internalLinkType: page + ":add to cart",
    internalLinkZoneName: page + ":modal:interactive parts diagram",
    internalLinkURL: linkUrl,
    clickInternalLinks: "true",
  }
  const { productInfo: product, page: pageState } =
    getAnalyticProductInfo(productInfo)
  if (pageState && pageState.pageInfo) {
    pageState.pageInfo["contentType"] = page
    if (
      typeof pageState.pageInfo.pageName === "string" &&
      pageState.pageInfo.pageName.match("::")
    ) {
      const pageName = pageState.pageInfo.pageName.replaceAll("::", `:${page}:`)
      pageState.pageName = pageName
      pageState.pageInfo.pageName = pageName
    }
  }

  const modifiedPageObj = pageState || { page }

  // pass page as modifiedPageObj (3rd arg) and product as 5th arg
  pushAnalyticsObjToDataLayer(eventInfo, event, modifiedPageObj, {}, product)
}
export const getAnalyticProductInfo = pdpInfo => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState("page")
  if (page) {
    const {
      user = { encodedEmailId: null, profileType: null },
      category = { productLocalCategory: null },
      pageInfo = { thumbnailImageUrl: null },
    } = page
    delete category["productLocalCategory"]
    delete user["encodedEmailId"]
    delete user["profileType"]
    delete pageInfo["thumbnailImageUrl"]
  }
  const {
    Name = "",
    quantity = 0,
    fileTitle = "",
    currentVarent: { imgUrl, label, centPrice, value },
    data: {
      ProductDescriptionProduct_s: productDescription,
      ProductCategory_s: productCategory,
    },
    pdpDetails: { pdp },
  } = pdpInfo

  const serviceVs = JSON.parse(localStorage.getItem("serviceVS"))
  const productInfo = {
    category: pdp?.data?.category1_s || "n/a",
    defaultImageName: imgUrl,
    description: sanitizeTextForAnalytics(productDescription || Name),
    frequency: "n/a",
    globalDiscount: 0,
    globalOffer: "n/a",
    globalPromotionPrice: centPrice,
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: sanitizeTextForAnalytics(productCategory),
    numberOfReviews: "n/a",
    pdpType: "regular finished goods & service parts",
    priceState: "regular price",
    productBasePrice: centPrice,
    productBrand: "kohler",
    productCategory: sanitizeTextForAnalytics(productCategory),
    productCollectionsName: pdp?.productBrand || "n/a",
    productColor: sanitizeTextForAnalytics(label),
    productCouponCode: "n/a",
    productCoupondiscount: 0,
    productFindingMethod: `pdp:${fileTitle}`,
    productID: value,
    productName: sanitizeTextForAnalytics(Name),
    productPartnerBuyNow: false,
    productRoom: page?.category?.room,
    productSalePrice: centPrice,
    productSaleable: true,
    productStatus: "in stock",
    productSuperSku: true,
    productTileName: sanitizeTextForAnalytics(Name),
    quantity,
    ratings: "n/a",
    waterSenseProduct: false,
    visualsearch: serviceVs ?? false,
  }

  return { productInfo, page }
}
